import * as Sentry from '@sentry/browser';

import { patchUser } from 'dux/user/actions';
import { trackHeapEvent } from 'dux/tracking/actions';

import { getGiftContent } from 'dux/gift/selectors';
import { getUserHasAcceptedTerms } from 'dux/user/selectors';

import { dateToUtc } from 'utils/dateUtils';
import * as GiftService from 'Services/GiftService';
import { isFetchError } from 'Services/HTTPError';

import {
  CREATE_GIFT_ERROR,
  CREATE_GIFT_REQUEST,
  CREATE_GIFT_SUCCESS,
  SET_SELECTED_GIFT,
} from './actionTypes';

export const setSelectedGift = selectedGift => ({
  type: SET_SELECTED_GIFT,
  selectedGift,
});

export const createOrderFromGiftRequest = () => ({
  type: CREATE_GIFT_REQUEST,
});

export const createOrderFromGiftSuccess = giftPubkey => ({
  type: CREATE_GIFT_SUCCESS,
  giftPubkey,
});

export const createOrderFromGiftError = error => ({
  type: CREATE_GIFT_ERROR,
  error,
});

export const createGift = values => async (dispatch, getState) => {
  const state = getState();

  if (!getUserHasAcceptedTerms(state)) {
    await dispatch(patchUser({ has_accepted_terms: true }));
  }
  const giftContent = getGiftContent(state);
  const products = giftContent.giftSets.find(gs => {
    return gs.label === values.selectedGift;
  });

  try {
    dispatch(createOrderFromGiftRequest());
    const giftObject = {
      giftee_info: {
        email: values.emailGiftee,
        last_name: values.lastnameGiftee,
        first_name: values.firstnameGiftee,
      },
      message: values.message,
      enabled_at: dateToUtc(values.enabled_at),
      occasion: `${values.occasion}`,
      products: products.productsSet,
    };
    dispatch(trackHeapEvent('Gifting Page - For Them filled'));

    const gift = await GiftService.post(giftObject);

    dispatch(createOrderFromGiftSuccess(gift.pubkey));
  } catch (error) {
    dispatch(createOrderFromGiftError(error));
    // ignore network errors
    if (!isFetchError(error)) {
      Sentry.captureException(error);
    }
  }
};
